import { Outlet } from "react-router-dom";

function DefaultPage() {
  return (
    <div className="min-h-dvh bg-background font-body">
      <Outlet />
    </div>
  );
}

export default DefaultPage;
